import React, { FC, ReactNode } from "react";
import { Box } from "@UI/Components/Box/Box";

import styled from "@emotion/styled";
import { ChakraStyledOptions } from "@chakra-ui/react";

const RoundedBox = styled(Box)`
  clip-path: ellipse(300% 100% at 50% 0);

  @media (min-width: 472px) {
    clip-path: ellipse(200% 100% at 50% 0);
  }
`;

interface Props extends ChakraStyledOptions {
  children: ReactNode;
  variant?: "rounded" | "normal";
}

export const DottedJumbotron: FC<Props> = (props) => {
  const { children, variant = "normal", ...rest } = props;
  const BoxVariant = variant === "rounded" ? RoundedBox : Box;
  return (
    <BoxVariant
      width="100%"
      background="sand.100"
      overflow="hidden"
      position="relative"
      {...(variant === "normal" ? { mb: "-35px" } : {})}
      {...rest}
    >
      <Box position="relative" zIndex="1">
        {children}
      </Box>
    </BoxVariant>
  );
};
